import Route from '@ember/routing/route';
import { A } from '@ember/array';
import { inject as service } from '@ember/service';

class MessageCenterRoute extends Route {
  @service('commands/company-commands')
  companyCommandService;

  @service('error-tracker')
  errorTracker;

  @service('state-manager-hybrids/recent-threads-state-manager-hybrid')
  recentThreadsHybrid;

  @service
  session;

  @service
  router;

  beforeModel() {
    const { currentUser } = this.session;

    if (currentUser.isBuyer && currentUser.company.isNeedsCreditCard) {
      this.router.replaceWith('projects');
    }
  }

  /**
   * @inheritDoc
   */
  model() {
    const { currentUser } = this.session;

    if (!currentUser.isBuyer) {
      return A();
    }

    if (!currentUser.company) {
      this.errorTracker.error(`message-center-route-model -- company not found for user id ${currentUser.id}`, this);
      return A();
    }

    return this.companyCommandService.loadBlockedUsersForCompany(currentUser.company.id);
  }

  setupController(mcController) {
    super.setupController(...arguments);

    this.recentThreadsHybrid.set('messageCenterActive', true);
    mcController._setupDOM();

    if (mcController.pageSetupComplete) {
      this.recentThreadsHybrid.updateMostRecentThreads(true, true);
    }
  }

  resetController(mcController, isExiting) {
    super.resetController(...arguments)

    if (isExiting) {
      this.recentThreadsHybrid.set('messageCenterActive', false);

      // Mark the current thread read up to the last message sent before opening the thread.
      mcController._markThreadRead({ timestamp: mcController.lastRouteChangeTimestamp });
      mcController._teardownDOM();
      mcController.closeProfileOverlay();
    }
  }
}

export default MessageCenterRoute;
